import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiMessageCircle, FiFolder, FiTag, FiClock, FiUser } from 'react-icons/fi';
import { useAuthStore } from '../../store/authStore';
import './MobileBottomNav.css';

const PROJECT_ROLES = ['ceo', 'co_ceo', 'company_manager', 'sales_head', 'production_head', 'manager'];

const isChats = (p) => /^\/dashboard\/?$/.test(p) || p.startsWith('/dashboard/channel');

const ITEMS = {
  chats: { label: 'Chats', icon: <FiMessageCircle />, path: '/dashboard', match: isChats },
  projects: { label: 'Projects', icon: <FiFolder />, path: '/dashboard/projects' },
  tickets: { label: 'Tickets', icon: <FiTag />, path: '/dashboard/tickets' },
  clientTickets: { label: 'Tickets', icon: <FiTag />, path: '/dashboard/tickets', match: (p) => isChats(p) || p.startsWith('/dashboard/tickets') },
  attendance: { label: 'Attendance', icon: <FiClock />, path: '/dashboard/attendance' },
  profile: { label: 'Profile', icon: <FiUser />, path: '/dashboard/profile' },
};

// Same pages the sidebar offers each role
function itemsFor(role) {
  if (role === 'client') return ['clientTickets', 'profile'];
  if (role === 'attendance_manager') return ['attendance', 'profile'];
  return ['chats', ...(PROJECT_ROLES.includes(role) ? ['projects'] : []), 'tickets', 'attendance', 'profile'];
}

// App-style tab bar shown at the bottom of every mobile screen (hidden on desktop via CSS)
function MobileBottomNav() {
  const { user } = useAuthStore();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  if (!user) return null;

  return (
    <nav className="mobile-bottom-nav" aria-label="Main">
      {itemsFor(user.role).map(key => {
        const item = ITEMS[key];
        const active = item.match ? item.match(pathname) : pathname.startsWith(item.path);
        return (
          <button
            key={key}
            type="button"
            className={`mbn-item ${active ? 'active' : ''}`}
            aria-current={active ? 'page' : undefined}
            onClick={() => navigate(item.path)}
          >
            <span className="mbn-icon">
              {key === 'profile' && user.profilePicture
                ? <img className="mbn-avatar" src={user.profilePicture} alt="" />
                : item.icon}
            </span>
            <span className="mbn-label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default MobileBottomNav;
